export default {
    messages: []
}
